import type { IntegrationSuggestion } from '@/features/integrations/integrations.types';

export const suggestionExperimentProperties = (
  suggestion: IntegrationSuggestion,
  surface: string
) => {
  const chip = surface === 'home' ? suggestion.chip : undefined;
  return chip
    ? {
        experiment_id: chip.experiment_id,
        variant_id: chip.variant_id,
        config_revision: chip.revision,
      }
    : {};
};
